import apiService from "./apiService";
import AppConstants from "../appConstants";

class ChannelService {
    getAllChannel(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CHANNEL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getChannelDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_CHANNEL}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerChannel(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CHANNEL, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteChannel(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_CHANNEL}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CHANNEL_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new ChannelService();
